import React from 'react';
import { Phone } from 'lucide-react';

const ChangingWill = () => {
  return (
    <div className="space-y-6">
      <div className="text-center space-y-6">
        <a 
          href="tel:01332424511"
          className="inline-flex items-center justify-center px-6 py-4 bg-[#F16745] text-white rounded-lg hover:bg-[#F16745] transition-colors group"
        >
          <Phone className="h-5 w-5 mr-3" />
          <span className="text-xl font-semibold">01332 424 511</span>
        </a>
      </div>
    </div>
  );
};

export default ChangingWill; 